






































import { Component, Vue } from 'vue-property-decorator';
import { Log } from '@/services/api/nswag/stapiclient_generated';
import { stAdminApi } from '@/services/st-api';
import StTabs from '@/components/tabs/StTabs.vue';
import AccountSettingsInvoice from '@/views/Settings/AccountSettingsInvoice.vue';

@Component({
  components: { StTabs, AccountSettingsInvoice },
})
export default class Logs extends Vue {
  logs: Log[] = [];
  interval: any;
  level = '';

  displayErrors() {
    this.level = 'Error';
  }

  displayAll() {
    this.level = '';
  }

  get entries(): Log[] {
    if (this.level) {
      return this.logs.filter((_) => _.level == this.level);
    }

    return this.logs;
  }

  async mounted() {
    this.logs = await stAdminApi.getLogs();

    this.interval = setInterval(async () => {
      this.logs = await stAdminApi.getLogs();
    }, 20000);
  }

  destroyed() {
    clearInterval(this.interval);
  }
}
